import GradientButton from '@/Component/Common/Forms/GradientButton';
import PrimaryButton from '@/Component/Common/Forms/PrimaryButton';
import ConfirmationModal from '@/Component/Common/Modal/ConfirmationModal';
import { InfoCircleSVG, LoaderSVG } from '@/Component/Common/SVGs/CommonSVG';
import { AppStore } from '@/lib/store';
import { CampaignQuotationApprovedAPI, ContinueWithSameQuotationAPI, InfluencerArchiveAPI } from '@/Utils/APIRequest/Endpoints';
import usePost from '@/Utils/Hooks/usePost';
import { useSearchParams } from 'next/navigation';
import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import QuotationApproveModal from './QuotationApproveModal';
import { formatNumberWithCommas } from '@/Utils/Other/FormatNumberWithCommas';
import { CustomToast } from '@/Utils/CustomToast';
import BorderButton from '@/Component/Common/Forms/BorderButton';
import { ImageLoaderSVG } from '@/Component/Common/SVGs/AuthSVG';

const QuotationInfo = (props) => {
    const { quotationInfo, ManagementDetailDataRefetch, MainListRefetch, influencerId, setOpenSideModal, params, setParams, listMutate, setApplyModal, setApproveModalOpen, translations } = props;
    const userDetails: any = useSelector((state: AppStore) => state.userDetailSlice?.userDetails);
    const searchParams = useSearchParams();
    const id = searchParams.get("id");
    const tab = searchParams.get("tab");
    const [archivedOpenModal, setArchivedOpenModal] = useState<String>('');

    const { isPending, mutate } = usePost(`${ContinueWithSameQuotationAPI}/${quotationInfo?.campaign?.campaignInfluencers?.[0]?.id}`, null, (response) => {
        if (response?.status == 200 || response?.status == 201) {
            ManagementDetailDataRefetch();
        }
    }, 'patch');

    const handleApprove = () => {
        setApproveModalOpen({
            id: quotationInfo?.campaign.id,
            influencerId: influencerId,
            campaign_influencer_id: quotationInfo?.campaign?.campaignInfluencers?.[0]?.id,
            ManagementDetailDataRefetch: ManagementDetailDataRefetch,
            amount: quotationInfo?.campaign?.campaignInfluencers?.[0]?.influencer_budget,
            currency: quotationInfo?.campaign?.campaignInfluencers?.[0]?.currency,
            is_budget_changed: quotationInfo?.campaign?.campaignInfluencers?.[0]?.is_budget_changed,
            new_amount: quotationInfo?.campaign?.campaignInfluencers?.[0]?.influencer_budget_new,
            ManagementDetailData: quotationInfo,
        });
    }

    const handleAccept = () => {
        mutate();
    }

    const handleEditPrice = () => {
        setApplyModal(quotationInfo?.campaign);
    }

    const confirmationMessage = quotationInfo?.campaign?.campaignInfluencers?.[0]?.is_archived ? translations?.unarchiveMessage : translations?.archiveMessage

    // Patch  API
    const { isPending: archivedPending, mutate: archivedMutate } = usePost(`${InfluencerArchiveAPI}/${quotationInfo?.campaign?.campaignInfluencers?.[0]?.id}`, null, (response) => {
        if (response?.status == 200 || response?.status == 201) {
            setArchivedOpenModal("")
            ManagementDetailDataRefetch();
            // Messages hub detail query is separate from sidebar refetch
            MainListRefetch?.();
        }
    }, 'patch');


    const handleArchive = () => {
        setArchivedOpenModal(quotationInfo?.campaign?.campaignInfluencers?.[0]?.id)
    }

    const callbackFunctionArchive = () => {
        archivedMutate();
    }

    console.log(quotationInfo?.campaign);

    const afterQuoteStatus = {
        "drafting_deliverables": true,
        "draft_available": true,
        "posting_deliverables": true,
        "completion_request": true
    }


    return (
        <>
            <div className='px-4 pb-4'>
                <div className='flex items-center justify-between'>
                    <div className='flex items-center gap-5'>
                        {(quotationInfo?.campaign?.campaignInfluencers?.[0]?.influencer_budget > 0 || quotationInfo?.campaign?.campaignInfluencers?.[0]?.influencer_budget_new > 0) &&
                            <div className='flex flex-col'>
                                <span className='font-semibold text-xl'>
                                    ${formatNumberWithCommas(quotationInfo?.campaign?.campaignInfluencers?.[0]?.influencer_budget)} {quotationInfo?.campaign?.campaignInfluencers?.[0]?.currency}
                                    {quotationInfo?.campaign?.campaignInfluencers?.[0]?.is_budget_changed &&
                                        <span className=' text-gray-500'>&nbsp;&#x2192; ${formatNumberWithCommas(quotationInfo?.campaign?.campaignInfluencers?.[0]?.influencer_budget_new)} {quotationInfo?.campaign?.campaignInfluencers?.[0]?.currency}
                                        </span>
                                    }
                                </span>
                                <span className='text-sm'>💰 {translations?.cash}</span>
                            </div>}
                        {quotationInfo?.campaign?.product_value > 0 &&
                            <div className='flex flex-col'>
                                <span className='font-semibold text-xl'>${formatNumberWithCommas(quotationInfo?.campaign?.product_value)} {quotationInfo?.campaign?.campaignInfluencers?.[0]?.currency}</span>
                                <span className='text-sm'><span role="img" aria-label="cash" className="mr-1">🎁</span>{translations?.productValue}</span>
                            </div>}
                    </div>
                    {quotationInfo?.campaign?.status == 'running' &&
                        <>
                            {(userDetails?.role === "brand" && quotationInfo?.campaign?.campaignInfluencers?.[0]?.status == 'quotation_available') &&
                                <div className='flex items-center gap-2'>
                                    <PrimaryButton customClass='flex items-center justify-center gap-1.5' onClick={handleApprove}>
                                        {translations?.approve}
                                    </PrimaryButton>
                                    {!quotationInfo?.campaign?.campaignInfluencers?.[0]?.is_archived &&
                                        <BorderButton customClass='flex items-center justify-center gap-1.5' onClick={handleArchive} >
                                            {translations?.archive}
                                        </BorderButton>
                                    }
                                </div>
                            }
                            {(userDetails?.role === "brand" && afterQuoteStatus[quotationInfo?.campaign?.campaignInfluencers?.[0]?.status] && quotationInfo?.campaign?.campaignInfluencers?.[0]?.is_budget_changed) &&
                                <div className='flex items-center gap-2'>
                                    <PrimaryButton customClass='flex items-center justify-center gap-1.5' onClick={handleApprove}>
                                        {translations?.approve}
                                    </PrimaryButton>
                                </div>
                            }
                            {(userDetails?.role === "influencer" && quotationInfo?.campaign?.campaignInfluencers?.[0]?.status !== 'closed') &&
                                <div className='flex items-center gap-2'>
                                    {/* {quotationInfo?.campaign?.campaignInfluencers?.[0]?.is_campaign_update && 
                                    <BorderButton customClass='flex items-center justify-center gap-1.5' onClick={handleAccept} >
                                        {translations?.accept}
                                        {isPending && <ImageLoaderSVG />}
                                    </BorderButton>
                                    } */}
                                    {(quotationInfo?.campaign?.is_barter == "true" && quotationInfo?.campaign?.campaignInfluencers?.[0]?.is_campaign_update) &&
                                        <PrimaryButton customClass='flex items-center justify-center gap-1.5' onClick={handleEditPrice} >
                                            {translations?.resubmit}
                                        </PrimaryButton>
                                    }
                                    {quotationInfo?.campaign?.is_barter == "false" &&
                                        <PrimaryButton customClass='flex items-center justify-center gap-1.5' onClick={handleEditPrice} >
                                            {translations?.editQuotation}
                                        </PrimaryButton>
                                    }
                                </div>
                            }
                        </>
                    }
                </div>
                {(quotationInfo?.campaign?.campaignInfluencers?.[0]?.message !== null || quotationInfo?.campaign?.campaignInfluencers?.[0]?.message !== "") &&
                    <div className='bg-primary/10 mt-4 py-2 px-4 rounded'>
                        <label className='text-primary font-medium'>{translations?.message}</label>
                        <p className='text-tertiary text-xs font-medium'>{quotationInfo?.campaign?.campaignInfluencers?.[0]?.message}</p>
                    </div>}
            </div>
            {userDetails?.role === "brand" &&
                <div className='text-tertiary bg-lightGray/30 px-4 rounded-b-xl text-xs py-1'>
                    {translations?.quoteMessage}
                </div>}

            {archivedOpenModal && <ConfirmationModal loader={archivedPending} modal={archivedOpenModal} args={{ message: confirmationMessage, icon: <InfoCircleSVG customClass="h-14 w-14 text-yellow-400" /> }} setModal={setArchivedOpenModal} callbackFunction={callbackFunctionArchive} />}
        </>

    )
}

export default QuotationInfo
